module.exports = __webpack_public_path__ + "img/Home_Tablet_05.0ece320d.jpg";